import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { GroupsService } from "../../../../auth/service/group.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SkillsService } from "app/auth/service/skills.service";
import { CitiesService } from "../../../../auth/service/cities.service";
import { UserFigureService } from "../../../../auth/service/user-figure.service";
import { CollaboratorsService } from "../../../../modules/collaborators/collaborators.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-groups-form",
  templateUrl: "./groups-form.component.html",
  styleUrls: ["./groups-form.component.scss"],
})
export class GroupsFormComponent implements OnInit {
  public formGroup: FormGroup;

  public contentHeader: IContentHeader;

  public currentGroup: any;

  public users_list: any = [];

  public has_members_list: boolean = false;

  public groupConstructor: any;

  public showErrors: boolean = false;

  constructor(
    private _formBuilder: FormBuilder,
    public _utilService: UtilsService,
    private _userService: UserService,
    private _groupService: GroupsService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    public _skillService: SkillsService,
    public _figureService: UserFigureService,
    public _citiesService: CitiesService,
    public _authenticationService: AuthenticationService,
    private _collaboratorService: CollaboratorsService,
  ) {
    this.formGroup = this._formBuilder.group({
      name: new FormControl("", [Validators.required, Validators.minLength(3), Validators.maxLength(255)]),
      leader: new FormControl(undefined),
      description: new FormControl("", [Validators.maxLength(16777215)]),
      enabled: new FormControl(false, [Validators.required, Validators.min(0), Validators.max(2)]),
      members: new FormControl([]),
    });

    this.groupConstructor = {
      skill: [],
      city: null,
    };
  }

  async ngOnInit() {
    this.users_list = await this._userService.getList("employee", null, true);
    const collaborators: any = await this._collaboratorService.getCollaboratorList();
    this.users_list = [...this.users_list, ...collaborators];
    await this._skillService.getList();
    await this._figureService.getList();

    this._activatedRoute.params.subscribe(async (params) => {
      if (params.hasOwnProperty("group_id")) {
        this.currentGroup = await this._groupService.get(params.group_id);
        if (!this.currentGroup) {
          return this.router.navigateByUrl("/dashboard/groups");
        }
        this.formGroup.patchValue({
          name: this.currentGroup.name,
          leader: this.currentGroup.owner.hash,
          description: this.currentGroup.description,
          enabled: Boolean(this.currentGroup.enabled || 0),
          members: this.currentGroup.users_list ? this.currentGroup.users_list.split(",") : [],
        });

        this.has_members_list = true;
      }
    });

    const headerTitle: string = await this._utilService.translate("MENU.GROUPS");
    const breadcrumTailStr: string = await this._utilService.translate(this.currentGroup ? "EDIT" : "ADD");

    this.contentHeader = {
      headerTitle: breadcrumTailStr,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.USERS",
            isLink: false,
          },
          {
            name: headerTitle,
            isLink: true,
            link: "/dashboard/groups",
          },
          {
            name: breadcrumTailStr,
            isLink: false,
          },
        ],
      },
    };
  }

  memberList() {
    return this.formGroup.value.members.map((member_hash: string) => this.users_list.find((user: any) => user.hash === member_hash)).filter((i) => i);
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  async save() {
    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      return false;
    }

    let data: any = this.formGroup.value;
    data.enabled = data.enabled ? 1 : 0;

    this._utilService.showLoading();
    if (this.currentGroup) {
      if (!this._authenticationService.hasCapability("edit_group")) {
        window.history.back();
        return false;
      }
      await this._groupService
        .update(this.currentGroup.id, data)
        .then(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_GROUP" }).then(async () => this.router.navigateByUrl("/dashboard/groups"));
        })
        .catch(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_EDIT_GROUP" });
        });
    } else {
      if (!this._authenticationService.hasCapability("create_group")) {
        window.history.back();
        return false;
      }
      await this._groupService
        .create(data)
        .then(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALSuccess({ text: "SUCCESS_UPLOAD_GROUP" }).then(async () => this.router.navigateByUrl("/dashboard/groups"));
        })
        .catch(async () => {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({ text: "ERROR_UPLOAD_GROUP" });
        });
    }
  }
}
